import { AppContainer } from '../app.types/state';
import { ProductContainer } from '../app.containers/ProductContainer';

export async function createProductContainer(self: AppContainer) {
  return new ProductContainer({
    ...self.context,
  });
}
